import { first } from 'lodash';

export const DEFAULT_PICKER_PAGE_SIZE = 20;

export async function findOrFetchPickerItem<T extends { id: string }>(
  id: string,
  dataList: T[] | null | undefined,
  fetchFn: (ids: string[]) => Promise<T[]>
): Promise<T | null> {
  const found = dataList?.find((item) => item.id === id);
  if (found) {
    return found;
  }

  const results = await fetchFn([id]);
  return first(results) ?? null;
}
